import { render, staticRenderFns } from "./BannerHome.vue?vue&type=template&id=75de8ba4&"
import script from "./BannerHome.vue?vue&type=script&lang=js&"
export * from "./BannerHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports